<template>
  <page-outline>
    <template slot="pageContent">
      <div :class="['content bg-light',{ expanded: !isSidebarOpen }]">
        <div>
          <!-- title -->
          <b-container fluid>
            <div class="content-title">
              <b-row>
                <h1>Reconciliation Rules Configuration</h1>
              </b-row>
              <b-row>
                <span>Configure the 4-step matching cascade and candidate selection strategy</span>
              </b-row>
            </div>
            <b-row style="background-color: #f8fafc;" class="card px-6 pt-6">
              <div class="flex items-center">
                <h4 style="display: flex; align-items: center; gap: 1rem; font-size: 1.5rem;"><i class="fa-regular fa-filter"></i>Universal Filters (Hard-coded)</h4>
              </div>
              <span data-slot="card-description" class="subtitle">These filters are always applied first. Payments failing these are rejected or flagged as exceptions.</span>

              <div style="display: grid; grid-template-columns: 1fr 1fr 1fr 1fr; width: 100%; gap: 1rem; margin: 1rem 0rem;">
                <div style="display: grid; background-color: white; border: 1px solid #e2e8f0; padding: 1rem; border-radius: 0.25rem;">
                  <span style="font-weight: bold;">1. VIBAN Check</span>
                  <span style="color: #45556c;">Must exist & be active</span>
                </div>
                <div style="display: grid; background-color: white; border: 1px solid #e2e8f0; padding: 1rem; border-radius: 0.25rem;">
                  <span style="font-weight: bold;">2. Client Check</span>
                  <span style="color: #45556c;">Client active & not suspended</span>
                </div>
                <div style="display: grid; background-color: white; border: 1px solid #e2e8f0; padding: 1rem; border-radius: 0.25rem;">
                  <span style="font-weight: bold;">3. Status Check</span>
                  <span style="color: #45556c;">Invoice must be Definitive/Open</span>
                </div>
                <div style="display: grid; background-color: white; border: 1px solid #e2e8f0; padding: 1rem; border-radius: 0.25rem;">
                  <span style="font-weight: bold;">4. Payment Window</span>
                  <span style="color: #45556c;">Inside term + grace period</span>
                </div>
              </div>
            </b-row>
            <b-row class="card px-6 pt-6">
              <span class="title">Configuration Template</span>
              <span class="subtitle">Select a base configuration</span>
              <div style="display: grid; grid-template-columns: 1fr 1fr 1fr; gap: 1rem;">
                <div @click="updateConfiguration('ecommerce')" class="card px-6 pt-6" :style="{cursor: 'pointer', border: configuration == 'ecommerce' ? '2px solid #bfdbfe': '1px solid #0000001a'}">
                  <div style="margin-bottom: 3rem; display: flex; align-items: center; justify-content: space-between;">
                    <span class="title">E-commerce Standard</span>
                    <i v-if="configuration == 'ecommerce'" style="color: #bfdbfe; font-weight: bold;" class="fa-regular fa-check"></i>
                  </div>
                  <span style="margin: 1rem 0rem; color: #4a5565;">Optimized for high-volume e-commerce with exact matching and minimal tolerance</span>
                </div>
                <div @click="updateConfiguration('traditional')" class="card px-6 pt-6" :style="{cursor: 'pointer', border: configuration == 'traditional' ? '2px solid #bfdbfe': '1px solid #0000001a'}">
                  <div style="margin-bottom: 3rem; display: flex; align-items: center; justify-content: space-between;">
                    <span class="title">Traditional B2B</span>
                    <i v-if="configuration == 'traditional'" style="color: #bfdbfe; font-weight: bold;" class="fa-regular fa-check"></i>
                  </div>
                  <span style="margin: 1rem 0rem; color: #4a5565;">Full feature set for B2B with credit notes, partial payments, and FIFO</span>
                </div>
              </div>
            </b-row>

            <b-row  class="card px-6 pt-6">
              <div style="display: flex; width: 100%; gap: 1rem; justify-content: space-between;">
                <div style="display: grid;">
                  <span class="title">Configuration: Traditional B2B</span>
                  <span class="subtitle">Configure candidate selection and the rule cascade</span>
                </div>
                <button class="btn-outline btn-dark"><i class="fa-regular fa-save"></i>Save</button>
              </div>
              <div class="info-container" style="width: 100%;">
                <div style="display: flex; width: 100%; justify-content: space-between;">
                  <div style="display: flex; gap: 1rem; margin-bottom: 1rem;">
                    <i style="padding: 1rem; background-color: #e0e7ff; border-radius: .25rem;" class="fa-regular fa-list"></i>
                    <div style="display: grid;">
                      <span style="color: #312c85; font-size: 1.1rem; font-weight: bold;">Selection and Sorting of Candidates</span>
                      <small style="color: #4338ca;">Sorts and filters invoices beefore matching</small>
                    </div>
                  </div>
                  <button class="btn btn-empty" style="background-color: white; cursor: pointer; display: flex; gap: 0.5rem; align-items: center;"><i class="fa-regular fa-gear"></i>Configure Strategy</button>
                </div>
                <div style="display: flex; gap: 1rem;">
                  <small><small style="font-weight: bold;">Primary Sort:</small> FIFO</small>
                  <small><small style="font-weight: bold;">Secondary:</small> None</small>
                  <small><small style="font-weight: bold;">Max Candidates:</small> 50</small>
                </div>
              </div>
              <span style="color: #6a7282 !important; font-weight: bold; display: flex; align-items: center; margin: 1rem 0rem; gap: 1rem;"><i class="fa-regular fa-arrow-down"></i>Then apply Allocation Rules (Sequential)</span>
              <div style="width: 100%;" v-if="rulesOrder != null">
                <div class="card" v-for="(item, index) in rulesOrder" :key="index">
                  <div style="display: flex; gap: 1rem; justify-content: space-between; padding: 1rem; align-items: center;">
                    <div style="display: flex; gap: 1rem; align-items: center;">
                      <span style="background-color: #fbf9fa !important; padding: 0.25rem 1rem;" class="btn-empty">{{ index + 1 }}</span>
                      <div>
                        <div @click="() => rules[item].isActive = !rules[item].isActive" :style="{display: 'flex','justify-content': rules[item].isActive ? 'end' : 'left', 'border-radius': '50px', 'height': '1rem', 'width': '2rem', 'background-color': rules[item].isActive ? 'black' : 'gray'}"><div  style="border-radius: 50px; width: 1rem; height: 1rem; background-color: white;"></div></div>
                      </div>
                      <div>
                        <div>
                          <span style="font-weight: bold; font-size: 1.1rem;">{{ rules[item].title }}</span>
                          <button class="btn" @click="() => rules[item].isOpen = !rules[item].isOpen">
                            <i :class="['fa-regular', {'fa-angle-up': rules[item].isOpen, 'fa-angle-down': !rules[item].isOpen }]"></i>
                          </button>
                        </div>
                        <small style="color: #6a7282;" v-if="!rules[item].isOpen">{{ rules[item].description }}</small>
                      </div>
                    </div>
                    <div style="display: flex;">
                      <configuration-modal @update="updatedRule => updateRule(item, updatedRule)" :config="rules[item]"></configuration-modal>
                      <button style="padding: 0.5rem;" :class="['btn', {disabled: index == 0}]" @click="switchOrder(rules[item], index, 1)">
                        <i class="fa-regular fa-arrow-up"></i>
                      </button>
                      <button style="padding: 0.5rem;" :class="['btn', {disabled: index == 3}]" @click="switchOrder(rules[item], index, 0)">
                        <i class="fa-regular fa-arrow-down"></i>
                      </button>
                    </div>
                  </div>
                  <hr style="margin: 0;" v-if="rules[item].isOpen">
                  <div style="display: grid; grid-template-columns: 1fr 1fr; padding: 1rem; background-color: #f8f9fa !important;" v-if="rules[item].isOpen">
                    <small style="color: #6a7282;" v-for="(param, i) in Object.entries(rules[item].param)" :key="i">
                      {{ param[0].split('_').map(e => {return e.slice(0,1).toUpperCase() + e.slice(1)}).join(' ') }}: <small style="font-weight: bold; color: black;">{{ param[1].value }}</small>
                    </small>
                  </div>
                </div>
              </div>
              <div v-else class="card empty">
                <b-spinner label="Loading..."></b-spinner>
              </div>
            </b-row>
          </b-container>
        </div>
      </div>
    </template>
  </page-outline>
</template>

<script>
import PageOutline from '@/components/common/PageOutline.vue'
import ConfigurationModal from '../../components/common/configurationModal.vue'

export default {
  name: 'ReconciliationRulesPage',
  components: {
    'page-outline': PageOutline,
    'configuration-modal': ConfigurationModal
  },
  data () {
    return {
      isSidebarOpen: true,
      rulesOrder: [0,1,2,3],
      rules: [
        {
          title:'1. Match Exact Montant', 
          description: 'Associer un paiement à une facture unique lorsque le montant correspond exactement',
          isActive: true,
          isOpen: false,
          param: {
            tolerance_eur: {
              value: 0.01,
              description: 'Tiny tolerance for "exact" matches',
              impact: 'Prevents floating point mismatch issues',
              example: '0.01 allows 1 cent difference',
              type: 'number'
            }
          }
        },
        {
          title:'2. Match Partial Group', 
          description: 'Allouer un paiement à une somme de factures (groupé) ou absorber un paiement partiel',
          isActive: true,
          isOpen: false,
          param: {
            max_invoices: {
              value: 5,
              description: 'Maximum invoices to group together',
              impact: 'Limits complexity of many-to-one matches',
              example: '5 invoices max per payment',
              type: 'number'
            },
            selection_strategy: {
              value: 'Oldest First',
              description: 'Which invoices to pick for the group',
              impact: 'Determines which specific invoices get paid',
              example: 'Oldest First (FIFO)',
              options: ['FIFO (Oldest First)', 'LIFO (Newest First)', 'Due Date Priority', 'Oldest First'],
              type: 'string'
            },
            tolerance_eur: {
              value: 0.05,
              type: 'number'
            },
            allow_partial: {
              value: true,
              description: 'Allow payment to be less than invoice total',
              impact: 'Enables partial reconciliation',
              type: 'boolean'
            },
            max_partials_per_invoice: {
              value: 5,
              description: 'Max number of partial payments allowed on one invoice',
              impact: 'Prevents infinite small payments',
              type: 'number'
            },
          }
        },
        {
          title:'3. Match Montant Net', 
          description: 'Réconcilier un paiement avec le solde net (après crédits/remboursements)',
          isActive: true,
          isOpen: false,
          param: {
            credit_priority: {
              value: 'Oldest First',
              description: 'Order of applying credit notes',
              impact: 'Which credits are used up first',
              example: 'Oldest First',
              options: ['FIFO (Oldest First)', 'LIFO (Newest First)', 'Due Date Priority', 'Oldest First'],
              type: 'string'
            },
            auto_apply_credits: {
              value: true,
              description: 'Automatically deduct credit notes from invoice balance',
              impact: 'Enables net matching',
              type: 'boolean'
            } 
          }
        },
        {
          title:'4. Match par tolérance', 
          description: 'Absorber de petits écarts via OD automatique',
          isActive: true,
          isOpen: false,
          param: {
            absolute_tolerance_eur: {
              value: 0.5,
              description: 'Max absolute difference to auto-write-off',
              impact: 'Creates automatic OD',
              example: '€0.50',
              type: 'number'
            },
            relative_tolerance_percent: {
              value: 0.1,
              description: 'Max percentage difference',
              impact: 'Scales with payment amount',
              example: '1%',
              type: 'number'
            },
            create_journal_entry: {
              value: true,
              description: 'Create OD journal entry automatically',
              impact: 'Accounting automation',
              type: 'boolean'
            },
          }
        },
      ],
      configuration: 'traditional'
    }
  },
  methods: {
    switchOrder (item, index, order){
      let temp = order == 1 ? this.rules[index - 1] : this.rules[index + 1]
      if(order == 1) {
        this.rules[index - 1] = item
      } else {
        this.rules[index + 1] = item
      }
      this.rules[index] = temp
      this.rulesOrder = [0,1,2,3]
    },
    updateConfiguration(method){
      this.configuration = method
    },
    updateRule (index, updatedConfig){
      this.rules.splice(index, 1, updatedConfig)
    }
  }
}
</script>
<style scoped>

  .card{
    min-height: fit-content !important;
  }

  .card .title{
    font-size: 1.2rem;
    font-weight: bold;
  }

  .card .subtitle {
    color: #717182;
    font-size: 1.1rem;
  }

  .content-title{
    margin: 1.5rem 0rem;
  }

  .info-container{
    background-color: #eef2ff80;
    border: 1px solid #e0e7ff;
    color: #312c85;
    padding: 1rem;
    border-radius: .625rem;
    margin: 1rem 0rem;
  }

  .content-title>div>span{
    color: #000000a6;
    font-size: 1.1rem;
  }
</style>
